
function getLocale() {
  if (navigator.languages && navigator.languages.length) {
    return navigator.languages[0].split(/-/)[0].trim().toLocaleLowerCase();
  }

  return 'en';
}

export {
  getLocale,
}
